export const imageUrl = "https://staging-insa.s3.ap-south-1.amazonaws.com/partner-portal/assets";

export const listOfExperts: { name: string; value: string }[] = [
  { name: "Shivani Modi", value: "Shivani" },
  { name: "Shailesh Saxena", value: "Shailesh" },
  { name: "VK Suri", value: "Suri" },
  { name: "Priyanshi", value: "Priyanshi" }
];
